import React from "react";
import { Reveal } from "../hooks/useReveal";
import { whyReasons, missionParagraphs, flagImage } from "../data/siteContent";

const WhyDoingThis = () => {
  return (
    <section className="bg-parchment text-ink py-24 sm:py-36" data-testid="story-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
            <Reveal>
              <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
                <span className="h-px w-10 bg-gold/60" />
                U.S. Combat Veteran, Retired
              </div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-6 leading-[1.06]">
                Why I Am <em className="text-goldeep italic">Doing This</em>
              </h2>
              <div className="mt-10 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  alt="Proud folded American flag, honoring military service"
                  className="w-full h-72 sm:h-96 object-cover hover:scale-105 transition-transform duration-700"
                  src={flagImage}
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-12 sm:space-y-14">
              {whyReasons.map((reason) => (
                <Reveal key={reason.number}>
                  <div className="flex gap-6 sm:gap-10 items-start border-b border-ink/10 pb-12 sm:pb-14">
                    <span className="font-display text-goldeep/50 text-2xl sm:text-3xl italic shrink-0 leading-none pt-1">
                      {reason.number}
                    </span>
                    <p
                      className={
                        reason.big
                          ? "leading-relaxed font-display text-xl sm:text-2xl text-ink"
                          : "leading-relaxed text-ink/75 text-base sm:text-lg"
                      }
                    >
                      {reason.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal className="mt-16 sm:mt-20">
              <div className="bg-ink text-cream rounded-3xl p-8 sm:p-14 relative overflow-hidden">
                <div
                  className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold/10 blur-3xl"
                  aria-hidden="true"
                />
                <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
                  <span className="h-px w-10 bg-gold/60" />
                  The Mission
                </div>
                <div className="mt-8 space-y-6">
                  {missionParagraphs.map((para, idx) => (
                    <p
                      key={idx}
                      className={
                        idx === 0
                          ? "font-display text-lg sm:text-xl leading-snug text-cream"
                          : "text-cream/70 text-base sm:text-lg leading-relaxed"
                      }
                    >
                      {para}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDoingThis;
